// ----------------------------
// CAPTURE AGENT FROM URL
// ----------------------------
(function() {
  function getParam(param) {
    const url = new URL(window.location.href);
    return url.searchParams.get(param);
  }

  const agent = getParam('cs_agent');

  if (agent) {
    // Store in a 30-day cookie
    document.cookie = "cs_agent=" + agent + "; path=/; max-age=" + (30*24*60*60);
  }

  // ----------------------------
  // READ COOKIE
  // ----------------------------
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }

  const savedAgent = getCookie('cs_agent');

  if (savedAgent) {
    // ----------------------------
    // SEND TO SHOPIFY CART ATTRIBUTES
    // ----------------------------
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          cs_agent: savedAgent,
          site: "Canada"
        }
      })
    }).catch(() => {});
  }
})();
